import React, { useState, useRef, useEffect } from 'react';
import { Phone, MessageCircle, MapPin, Menu, X, ChevronRight, Camera, Globe } from 'lucide-react';

const CounselingCenter = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [showPhonePopup, setShowPhonePopup] = useState(false);
  const [showMessagePopup, setShowMessagePopup] = useState(false);

  const menuSectionRef = useRef(null);

  const sectionLabels = {
    education: "[학력]",
    experience: "[경력]",
    certification: "[자격]",
    papers: "[논문]",
  };

  const galleryImages = [
    "/img/a.JPG",
    "/img/b.JPG",
    "/img/c.JPG",
    "/img/1.jpeg",  // ← public 다음부터 시작
    "/img/2.jpeg",
    "/img/3.jpeg",
    "/img/4.jpeg",
    "/img/5.jpeg",
    "/img/6.jpeg",
    "/img/7.jpeg",
    "/img/8.jpeg",
    "/img/9.jpeg",
    "/img/10.jpeg",
    "/img/11.jpeg",
    "/img/12.jpeg",
    "/img/leaf.png"
  ];

  const menuItems = [
    "상담진 소개",
    "이용 안내 및 상담 신청",
    "오시는 길",
    "심리상담",
    "심리평가",
    "상담자 교육 및 전문 프로그램"
  ];

  const counselors = [
    {
      name: "김길문",
      position: "소장",
      order: ["education", "experience", "certification", "papers"],
      education: [
        "가톨릭대학교 대학원 심리학과 석사 졸업 (상담 및 임상심리 전공)",
        "가톨릭대학교 대학원 심리학과 박사 졸업 (상담심리 전공)"
      ],
      experience: [
        "현) 한양대 상담심리대학원 겸임교수",
        "현) 가톨릭대 상담심리대학원 출강",
        "현) 한국프로스포츠협회 위촉 심리상담사",
        "전) 기아자동차 심리상담실 마음산책 (소하리) 상담실장",
        "전) 삼성 밝음마음 정신과 상담원",
        "전) 연세대학교 학생상담센터 객원상담원",
        "전) 한국가이던스 심리상담센터 전임 및 객원 상담원",
        "전) 서울대 전기공학부 학생생활연구실 상담원"
      ],
      certification: [
        "한국심리학회 산하 한국상담심리학회 상담심리사 1급(414호)"
      ],
      papers: [
        "초보 상담자가 상담 회기 내에 경험한 어려움과 대처 과정: 질적 분석(2004)",
        "한국 중년 남성의 생성감 및 감정 표현 억제가 행복에 미치는 영향: 직장인 중년 남성을 중심으로(2020)",
        "중년 남성 개별화 척도의 개발 및 타당화(2022)"
      ]
    },
    {
      name: "윤운영",
      position: "소장",
      order: ["education", "experience", "certification", "papers"],
      education: [
        "가톨릭대학교 대학원 심리학과 석사 졸업(상담 및 임상심리 전공)",
        "가톨릭대학교 대학원 심리학과 박사 졸업(상담심리 전공)"
      ],
      experience: [
        "전) 우석대학교 상담심리학과 교수",
        "전) 가톨릭대학교 학생생활상담소 요일제상담원",
        "전) 아들러코리아 EAP 상담실장 (청주 LG전자)",
        "전) 충북청소년상담복지센터 외래상담원"
      ],
      certification: [
        "한국심리학회 산하 한국상담심리학회 상담심리사 1급(710호)",
      ],
      papers: [
        "집단따돌림 경험 여성에 대한 사례연구(2004)",
        "아동 및 청소년의 상실 경험에 대한 이해와 학교상담의 개입(2013)",
        "청소년기 상실 경험과 학교상담자의 상실상담 경험에 대한 합의적 질적 연구(2017)",
        "청소년기 상실 경험에 대한 합의적 질적 연구(2018)",
        "고등학교상담자의 상실상담 경험에 대한 합의적 질적 연구(2019)",
        "대학생의 청소년기 상실경험에 대한 정서표현과 부정적 정서조절 방략이 우울에 미치는 영향: 자존감의 매개효과(2019)"
      ]
    },
    {
      name: "채은옥",
      position: "책임상담사",
      order: ["certification", "experience", "education", "papers"],
      education: [
        "가톨릭대학교 대학원 심리학과 석사 졸업(상담 및 임상심리 전공)"
      ],
      experience: [
        "현) 성심 상담심리센터 홍대점 (2023년~ 현재)",
        "현) 살레시오 교육영성센터 (2003년 ~ 현재)",
        "전) 에브리마인드 심리상담센터(2019년~2023년)",
        "전) 가톨릭대학교 서울성모병원 임상심리수련 3년(2005년~2008년)",
        "전) 서울임상심리연구소 연구원(2001년 ~ 2002년)"
      ],
      certification: [
        "한국심리학회 산하 한국임상심리학회 임상심리전문가(531호)",
        "보건복지부 공인 정신건강임상심리사 1급(479호)",
        "\u00A0\u00A0: 가톨릭대학교 서울성모병원 임상심리수련 3년 ",
        "한국심리학회 산하 한국상담심리학회 외부수퍼바이저(심리검사 수퍼비전)"
      ],
      papers: [
        "위협 상황에서 걱정 많은 사람들의 대처 과정 특성(2005)"
      ]
    }
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleMenuItem = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };


  const openGallery = (index) => {
    setCurrentImageIndex(index);
    setIsGalleryOpen(true);
  };

  const closeGallery = () => {
    setIsGalleryOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const handleSideMenuClick = (index) => {
    // 사이드메뉴 닫기
    setIsMenuOpen(false);

    // 메뉴 섹션으로 스크롤
    setTimeout(() => {
      menuSectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

      // 해당 아코디언 열기
      setTimeout(() => {
        setOpenMenuIndex(index);
      }, 500); // 스크롤 완료 후 아코디언 열기
    }, 100); // 메뉴 닫기 애니메이션 완료 후 스크롤
  };

  // 올라가라 
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // 카카오맵 초기화
  useEffect(() => {
    console.log('🟡 카카오맵 로딩 시작');

    // 이미 로드되어 있는지 확인
    if (window.kakao && window.kakao.maps) {
      console.log('🟢 카카오맵이 이미 로드되어 있음');
      return;
    }


    const script = document.createElement('script');

    const appKey = process.env.REACT_APP_KAKAO_APP_KEY;
    script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=${appKey}&libraries=services&autoload=false`;
    script.onload = () => {
      console.log('🟢 스크립트 로드 완료');

      // autoload=false이므로 수동으로 로드
      if (window.kakao && window.kakao.maps) {
        window.kakao.maps.load(() => {
          console.log('🟢 카카오맵 라이브러리 로드 완료!');
          console.log('🔍 LatLng 확인:', window.kakao.maps.LatLng);
        });
      }
    };

    script.onerror = (error) => {
      console.log('🔴 스크립트 로딩 실패:', error);
    };

    document.head.appendChild(script);
  }, []);

  // 지도 생성 useEffect
  useEffect(() => {
    if (openMenuIndex === 2) { // "오시는 길" 메뉴가 열렸을 때
      console.log('🟡 지도 생성 시도 시작');

      const createMap = () => {
        const container = document.getElementById('map');
        console.log('🔍 지도 컨테이너:', container);
        console.log('🔍 kakao.maps 존재:', !!window.kakao?.maps);
        console.log('🔍 LatLng 존재:', !!window.kakao?.maps?.LatLng);

        if (window.kakao && window.kakao.maps && container) {
          try {
            console.log('🟢 지도 생성 조건 충족!');

            const options = {
              center: new window.kakao.maps.LatLng(37.5665, 126.9780),
              level: 3
            };

            const map = new window.kakao.maps.Map(container, options);
            console.log('🟢 지도 생성 완료!');

            // 주소로 위치 검색
            const geocoder = new window.kakao.maps.services.Geocoder();
            geocoder.addressSearch('서울특별시 마포구 동교동 154-12', function (result, status) {
              if (status === window.kakao.maps.services.Status.OK) {
                const coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);

                new window.kakao.maps.Marker({
                  map: map,
                  position: coords
                });

                map.setCenter(coords);
                console.log('🟢 마커 및 중심좌표 설정 완료!');
              }
            });

          } catch (error) {
            console.log('🔴 지도 생성 에러:', error);
          }
        } else {
          console.log('🟡 조건 미충족');
          console.log('  - kakao:', !!window.kakao);
          console.log('  - maps:', !!window.kakao?.maps);
          console.log('  - container:', !!container);

          // 조건이 안 맞으면 다시 시도
          setTimeout(createMap, 300);
        }
      };

      // 메뉴가 열린 후 잠시 기다렸다가 지도 생성
      setTimeout(createMap, 1000);
    }
  }, [openMenuIndex]);


  return (
    <div className="min-h-screen bg-white overflow-x-hidden pt-12">
      {/* Header */}
      <header className="bg-white shadow-sm p-4 lg:px-8 fixed top-0 z-50 w-full">
        <div className="flex items-center justify-between lg:max-w-7xl lg:mx-auto">
          <button onClick={toggleMenu} className="p-2 lg:hidden">
            <Menu size={24} color="#333" />
          </button>
          <h1 className="text-base lg:text-xl font-bold cursor-pointer text-gray-800 truncate px-2" onClick={scrollToTop}>성심상담심리센터(홍대점)</h1>

          {/* PC Navigation */}
          <nav className="hidden lg:flex space-x-8">
            {menuItems.map((item, index) => (
              <button
                key={index}
                onClick={() => handleSideMenuClick(index)}
                className="text-gray-700 hover:text-[#c7b299] px-3 py-2 rounded-md whitespace-nowrap"
              >
                {item}
              </button>
            ))}
          </nav>

          <div className="w-8 lg:hidden"></div>
        </div>
      </header>


      {/* Side Menu Overlay */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50"
          onClick={toggleMenu}
        >
          <div
            className="bg-white w-72 sm:w-80 h-full p-6 transform transition-transform duration-300"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-8">
              <h2 className="text-xl font-bold">메뉴</h2>
              <button onClick={toggleMenu} className="p-2">
                <X size={24} />
              </button>
            </div>
            <nav>
              {menuItems.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between py-4 border-b border-gray-100 cursor-pointer"
                  onClick={() => handleSideMenuClick(index)} // 이 부분 수정
                >
                  <span className="text-gray-700">{item}</span>
                  <ChevronRight size={16} color="#999" />
                </div>
              ))}
            </nav>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#faf8f5] to-[#f5f1ec] p-6 pb-8 pt-20 lg:py-20 lg:pb-4 overflow-hidden">
        <div className="lg:max-w-7xl lg:mx-auto lg:grid lg:grid-cols-2 lg:gap-12 lg:items-center">
          <div className="absolute right-0 top-0 w-48 h-48 opacity-20 lg:hidden">
            <div className="w-full h-full bg-gradient-to-br from-[#d9c9b8] to-[#c7b299] rounded-full transform rotate-12"></div>
          </div>

          <div className="relative z-10">
            <h2 className="text-3xl lg:text-5xl font-bold text-[#2d2d2d] mb-2 lg:mb-4 lg:leading-tight">
              당신에게<br />
              마음의 평화를<br />
              드리고 싶습니다
            </h2>
            <p className="text-[#666666] mb-6 lg:text-xl lg:mb-12">성심상담심리센터(홍대점)</p>

          </div>

          {/* Hero Image - PC Only */}
          <div className="hidden lg:block">
            <div className="absolute inset-0 overflow-hidden rounded-2xl">
              {/* 배경 식물 이미지 - PC만 */}
              <img
                src="/img/reaf.png"
                alt="배경 식물"
                className="hidden lg:block absolute right-0 top-0 w-1/4 h-full object-cover opacity-80"
                style={{
                  objectPosition: 'left center',
                  transform: 'scale(2.5) translateX(-100px)',  // X축 20px, Y축 50px 이동
                  transformOrigin: 'center top'        // 중심점 설정
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section>
        <div className="lg:max-w-7xl lg:mx-auto p-6 pt-10">
          <h2 className="hidden lg:block text-2xl lg:text-3xl font-bold text-center mb-8 text-gray-800">센터 갤러리</h2>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-4 mb-4">
            {galleryImages.slice(0, 8).map((image, index) => (
              <div key={index} className={`relative ${index >= 4 ? 'hidden lg:block' : ''}`}>
                <img
                  src={image}
                  alt={`센터 사진 ${index + 1}`}
                  className="w-full h-32 lg:h-48 object-cover rounded-lg cursor-pointer"
                  onClick={() => openGallery(index)}
                />
                {index === 3 && galleryImages.length > 4 && (
                  <div
                    className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center cursor-pointer lg:hidden"
                    onClick={() => openGallery(index)}
                  >
                    <div className="text-white text-center">
                      <Camera size={24} className="mx-auto mb-1" />
                      <span className="text-sm">{galleryImages.length - 4}+</span>
                    </div>
                  </div>
                )}
                {index === 7 && galleryImages.length > 8 && (
                  <div
                    className="absolute inset-0 bg-black bg-opacity-50 rounded-lg flex items-center justify-center cursor-pointer hidden lg:flex"
                    onClick={() => openGallery(index)}
                  >
                    <div className="text-white text-center">
                      <Camera size={24} className="mx-auto mb-1" />
                      <span className="text-sm">{galleryImages.length - 8}+</span>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Modal */}
      {isGalleryOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center">
          <div className="relative w-full h-full flex flex-col">
            <button
              onClick={closeGallery}
              className="absolute top-4 right-4 z-60 text-white p-2"
            >
              <X size={24} />
            </button>

            <div className="flex-1 flex items-center justify-center p-4">
              <button
                onClick={prevImage}
                className="absolute left-4 text-white p-2 bg-black bg-opacity-50 rounded-full"
              >
                <ChevronRight size={24} className="rotate-180" />
              </button>

              <img
                src={galleryImages[currentImageIndex]}
                alt={`갤러리 이미지 ${currentImageIndex + 1}`}
                className="max-w-full max-h-full object-contain"
              />

              <button
                onClick={nextImage}
                className="absolute right-4 text-white p-2 bg-black bg-opacity-50 rounded-full"
              >
                <ChevronRight size={24} />
              </button>
            </div>

            {/* Thumbnail Navigation */}
            <div className="flex justify-center p-4 space-x-2 overflow-x-auto">
              {galleryImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`썸네일 ${index + 1}`}
                  className={`w-12 h-12 object-cover rounded cursor-pointer border-2 ${index === currentImageIndex ? 'border-white' : 'border-transparent'
                    }`}
                  onClick={() => setCurrentImageIndex(index)}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Center Info Section */}
      <section className="p-6 lg:py-16 bg-[#faf8f5]">
        <div className="lg:max-w-7xl lg:mx-auto lg:grid lg:grid-cols-2 lg:gap-12 lg:items-center">
          <div className="lg:order-1">
            <h3 className="hidden lg:block text-2xl lg:text-3xl font-bold text-gray-800 mb-6">센터 소개</h3>
            <p className="text-gray-700 mb-4 lg:text-lg">
              성심상담심리센터(홍대점)은<br />
              당신의 그 어떤 마음이라도 함께 나누고<br />
              이해해가는 공간입니다.
            </p>
            <p className="text-gray-700 mb-6 lg:text-lg">
              성심상담심리센터(홍대점)은<br />
              한국상담심리학회 공인 상담심리사 1급이<br />
              운영하는 상담센터로, 한국상담심리학회의<br />
              상담심리사 윤리강령을 준수합니다.
            </p>
          </div>

          <div className="lg:order-2">
            <div className="bg-white rounded-lg p-4 mb-6 lg:mb-0">
              <h3 className="font-bold text-gray-800 mb-4 lg:hidden">센터 소개</h3>
              <img
                src="/img/7.jpeg"
                alt="센터 내부"
                className="w-full h-48 lg:h-80 object-cover rounded-lg mb-4"
              />
              <div className="text-center lg:hidden">
                <h4 className="font-bold text-gray-800 mb-2">=방문객=</h4>
                <p className="text-sm text-gray-600 mb-4">정현종</p>
                <div className="space-y-2 text-sm text-gray-600 text-left">
                  <p>사람이 온다는 건</p>
                  <p>실은 어마어마한 일이다.</p>
                  <p>그는</p>
                  <p>그의 과거와</p>
                  <p>현재와</p>
                  <p>그리고</p>
                  <p>그의 미래와 함께 오기 때문이다.</p>
                  <p>한 사람의 일생이 오기 때문이다.</p>
                  <p>부서지기 쉬운</p>
                  <p>그래서 부서지기도 했을</p>
                  <p>마음이 오는 것이다—그 갈피를</p>
                  <p>아마 바람은 더듬어볼 수 있을 </p>
                  <p>마음,</p>
                  <p>내 마음이 그런 바람을 흉내낸다면</p>
                  <p>필경 환대가 될 것이다. </p>
                </div>
                <p className="text-center text-[#c7b299] font-bold mt-4">
                  "지금-여기에 오신 당신을 환영합니다!"
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Menu Section */}
      <section className="lg:py-16" ref={menuSectionRef}>
        <div className="lg:max-w-7xl lg:mx-auto p-6">
          <h2 className="hidden lg:block text-2xl lg:text-3xl font-bold text-center mb-8 text-gray-800">주요 서비스</h2>
          <div>
            {menuItems.map((item, index) => (
              <div key={index}>
                <div
                  className="flex items-center justify-between py-4 border-b border-gray-100 cursor-pointer"
                  onClick={() => toggleMenuItem(index)}
                >
                  <span className="text-gray-700">{item}</span>
                  <ChevronRight
                    size={16}
                    color="#999"
                    className={`transform transition-transform ${openMenuIndex === index ? 'rotate-90' : ''}`}
                  />
                </div>

                {/* 토글 컨텐츠 */}
                {openMenuIndex === index && (
                  <div className="px-4 py-4 bg-gray-50">
                    {index === 0 && (
                      <div className="space-y-6">
                        <div className="mb-6">
                          <img
                            src="/img/intro.png"
                            alt="성심상담심리센터 상담진 단체 사진"
                            className="w-full h-full object-cover rounded-lg shadow-sm"
                          />
                        </div>
                        {counselors.map((counselor, counselorIndex) => (
                          <div key={counselorIndex} className="bg-white p-4 rounded-lg shadow-sm">
                            <div className="mb-3">
                              <h4 className="font-bold text-base text-gray-800">{counselor.name}</h4>
                              <p className="text-sm text-[#c7b299] font-medium">{counselor.position}</p>
                            </div>

                            <div className="space-y-3 text-sm">
                              {counselor.order.map((sectionKey) => (
                                <div key={sectionKey}>
                                  <h5 className="font-semibold text-gray-700 mb-1">{sectionLabels[sectionKey]}</h5>
                                  {counselor[sectionKey].map((line, i) => (
                                    <p key={i} className="text-gray-600 leading-relaxed">{line}</p>
                                  ))}
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {index === 1 && (
                      <div className="space-y-6">

                        {/* 신청 방법 버튼 */}
                        <div className="grid grid-cols-3 gap-2 mb-6">
                          <button
                            className="flex flex-col items-center py-4 px-3 bg-[#f5f1ec] border border-[#ccb59f] rounded-lg hover:bg-[#ede4d9] transition-colors"
                            onClick={() => setShowPhonePopup(true)}
                          >
                            <Phone size={20} color="#ccb59f" className="mb-2" />
                            <span className="text-sm font-medium text-[#2d2d2d]">전화신청</span>
                          </button>
                          <button
                            className="flex flex-col items-center py-4 px-3 bg-[#f5f1ec] border border-[#ccb59f] rounded-lg hover:bg-[#ede4d9] transition-colors"
                            onClick={() => setShowMessagePopup(true)}
                          >
                            <MessageCircle size={20} color="#ccb59f" className="mb-2" />
                            <span className="text-sm font-medium text-[#2d2d2d]">문자신청</span>
                          </button>
                          <a
                            href="https://form.naver.com/response/xRi0fmTA0ooc9Mkvg9cDSw"
                            target="_blank"
                            rel="noreferrer"
                            className="flex flex-col items-center py-4 px-3 bg-[#f5f1ec] border border-[#ccb59f] rounded-lg hover:bg-[#ede4d9] transition-colors cursor-pointer"
                          >
                            <Globe size={20} color="#ccb59f" className="mb-2" />
                            <span className="text-sm font-medium text-[#2d2d2d]">온라인신청</span>
                          </a>
                        </div>

                        {/* 상담 신청 방법 */}
                        <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                          <div className="space-y-3">
                            <div className="flex items-start space-x-3">
                              <div className="w-6 h-6 bg-[#ccb59f] text-white rounded-full flex items-center justify-center text-sm font-bold mt-0.5">1</div>
                              <div>
                                <p className="text-[#2d2d2d] font-medium">상담 신청</p>
                                <p className="text-sm text-[#666666]">홈페이지(온라인 신청서) / 전화 및 문자(02-332-1404)로 상담 신청</p>
                              </div>
                            </div>
                            <div className="flex items-start space-x-3">
                              <div className="w-6 h-6 bg-[#ccb59f] text-white rounded-full flex items-center justify-center text-sm font-bold mt-0.5">2</div>
                              <div>
                                <p className="text-[#2d2d2d] font-medium">일정 조정</p>
                                <p className="text-sm text-[#666666]">상담사와 일정 조정 후 예약 확정</p>
                              </div>
                            </div>
                            <div className="flex items-start space-x-3">
                              <div className="w-6 h-6 bg-[#ccb59f] text-white rounded-full flex items-center justify-center text-sm font-bold mt-0.5">3</div>
                              <div>
                                <p className="text-[#2d2d2d] font-medium">안내 문자</p>
                                <p className="text-sm text-[#666666]">예약 확정 후 상담 안내 문자 발송</p>
                              </div>
                            </div>
                            <div className="flex items-start space-x-3">
                              <div className="w-6 h-6 bg-[#ccb59f] text-white rounded-full flex items-center justify-center text-sm font-bold mt-0.5">4</div>
                              <div>
                                <p className="text-[#2d2d2d] font-medium">첫 상담</p>
                                <p className="text-sm text-[#666666]">센터 방문하여 첫 상담 진행</p>
                              </div>
                            </div>
                          </div>
                          <div className="mt-4 p-3 bg-[#f5f1ec] rounded-lg">
                            <p className="text-sm text-[#2d2d2d] font-medium">► 모든 서비스는 예약제로 운영합니다</p>
                          </div>
                        </div>

                        {/* 주의사항 */}
                        <div className="bg-[#f5f1ec] p-4 rounded-lg border border-[#ccb59f]">
                          <h4 className="font-semibold text-[#2d2d2d] mb-3">주의사항</h4>
                          <ul className="space-y-2 text-sm text-[#666666]">
                            <li className="flex items-start space-x-2">
                              <span className="text-[#ccb59f] mt-1">•</span>
                              <span>부득이한 사정으로 예약된 날짜에 방문이 어려울 경우, <strong>24시간 전까지</strong> 연락을 주십시오.</span>
                            </li>
                            <li className="flex items-start space-x-2">
                              <span className="text-[#ccb59f] mt-1">•</span>
                              <span>상담 중일 경우 통화가 어려우니, 필요한 내용을 <strong>문자(02-332-1404)</strong>로 남겨주시면 연락드리겠습니다.</span>
                            </li>
                          </ul>
                        </div>

                        {/* 운영 정보 */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ">
                          <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                            <h4 className="font-semibold text-[#2d2d2d] mb-3 flex items-center">
                              <span className="mr-2">►</span>운영 시간
                            </h4>
                            <div className="space-y-1 text-sm text-[#666666]">
                              <p><strong>평일:</strong> 10:00 - 20:00</p>
                              <p><strong>토요일:</strong> 10:00 - 17:00</p>
                              <p className="text-[#a08c75]"><strong>휴무:</strong> 일요일, 공휴일</p>
                            </div>
                          </div>

                          <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                            <h4 className="font-semibold text-[#2d2d2d] mb-3 flex items-center">
                              <span className="mr-2">►</span>상담 정보
                            </h4>
                            <div className="space-y-1 text-sm text-[#666666]">
                              <p><strong>진행:</strong> 주 1~2회</p>
                              <p><strong>시간:</strong> 1회 50분</p>
                              <p><strong>비용:</strong> 12만원/회</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {index === 2 && (
                      <div className="space-y-6">

                        {/* 지도 영역 */}
                        <div className="relative">
                          <div
                            id="map"
                            className="w-full h-64 rounded-lg"
                            style={{ zIndex: 1 }}
                          ></div>

                          {/* 지도 위 버튼들 */}
                          <div
                            className="absolute top-3 right-3 flex flex-col space-y-2"
                            style={{ zIndex: 999 }}
                          >
                            <button
                              onClick={() => window.open('https://map.kakao.com/?urlX=483331.9999999979&urlY=1127467.9999999981&urlLevel=3&itemId=1962675494&q=%EC%84%B1%EC%8B%AC%EC%83%81%EB%8B%B4%EC%8B%AC%EB%A6%AC%EC%84%BC%ED%84%B0%20%ED%99%8D%EB%8C%80%EC%A0%90&srcid=1962675494&map_type=TYPE_MAP')}
                              className="bg-white px-3 py-2 rounded-lg shadow-lg text-sm font-medium hover:bg-gray-50"
                            >
                              지도보기
                            </button>
                            <button
                              onClick={() => window.open('https://map.kakao.com/link/to/1962675494')}
                              className="bg-white px-3 py-2 rounded-lg shadow-lg text-sm font-medium hover:bg-gray-50"
                            >
                              길찾기
                            </button>
                          </div>
                        </div>

                        {/* 위치 정보 */}
                        <div className="bg-[#f5f1ec] p-4 rounded-lg border border-[#ccb59f]">
                          <h4 className="font-semibold text-[#2d2d2d] mb-3 flex items-center">
                            <MapPin size={18} color="#ccb59f" className="mr-2" />
                            서울특별시 월드컵북로2길 85, 삼통빌딩 302호
                          </h4>
                          <div className="space-y-2 text-sm text-[#666666]">
                            <p className="font-medium">► 홍대입구역, 버스 정류장에서 도보 2-3분 거리</p>
                            <div className="bg-white p-3 rounded border border-[#e8ddd4]">
                              <p className="mb-1"><strong>► 지하철 이용시:</strong></p>
                              <p>• 2호선: 2번 출구 이용</p>
                              <p>• 경의중앙선 및 공항철도: 3번 출구 이용</p>
                            </div>
                            <div className="bg-white p-3 rounded border border-[#e8ddd4]">
                              <p className="text-[#2d2d2d] mb-1"><strong>► 건물 정보:</strong></p>
                              <p className="font-medium">&lt;헤어 봄 스튜디오&gt;가 있는 빨간 벽돌 건물 3층</p>
                            </div>
                            <div className="bg-white p-3 rounded border border-[#e8ddd4]">
                              <p className="text-[#2d2d2d] mb-1"><strong>► 건물 내 주차 불가</strong></p>
                              <p className="font-medium">인근 공영주차장 혹은 홍익인간 오피스텔 주차장 이용을 추천드립니다.</p>
                            </div>
                          </div>
                        </div>

                        {/* 센터 정보 */}
                        <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                          <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                            <Phone size={16} color="#ccb59f" className="mr-2" />
                            연락처
                          </h5>
                          <p className="text-[#ccb59f] font-medium">02-332-1404</p>
                        </div>
                      </div>
                    )}

                    {index === 3 && (
                      <div className="space-y-6">

                        {/* 개인상담 */}
                        <div className="bg-[#f5f1ec] p-5 rounded-lg border border-[#ccb59f]">
                          <h4 className="font-bold text-[#2d2d2d] mb-4 text-lg flex items-center">
                            <span className="mr-2">■</span>개인상담
                          </h4>

                          <div className="space-y-4">
                            {/* 상담 대상 */}
                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                                <span className="mr-2">►</span>상담 대상
                              </h5>
                              <p className="text-[#666666]">청소년, 성인</p>
                            </div>

                            {/* 상담 주제 */}
                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-3 flex items-center">
                                <span className="mr-2">►</span>상담 주제
                              </h5>
                              <div className="grid grid-cols-1 gap-3">
                                <div className="flex items-start space-x-3 p-3 bg-[#faf8f5] rounded-lg">
                                  <span className="text-[#ccb59f] mt-1">▹</span>
                                  <div>
                                    <p className="font-medium text-[#2d2d2d]">정서 및 정신 건강</p>
                                    <p className="text-sm text-[#666666]">우울, 불안, 공황, 수면, 섭식, 중독 등</p>
                                  </div>
                                </div>
                                <div className="flex items-start space-x-3 p-3 bg-[#faf8f5] rounded-lg">
                                  <span className="text-[#a08c75] mt-1">▹</span>
                                  <div>
                                    <p className="font-medium text-[#2d2d2d]">가족 갈등</p>
                                    <p className="text-sm text-[#666666]">부모-자녀 관계, 부부 및 커플 관계 등</p>
                                  </div>
                                </div>
                                <div className="flex items-start space-x-3 p-3 bg-[#faf8f5] rounded-lg">
                                  <span className="text-[#8b7355] mt-1">▹</span>
                                  <div>
                                    <p className="font-medium text-[#2d2d2d]">직무 스트레스</p>
                                    <p className="text-sm text-[#666666]">업무 관련 스트레스 및 번아웃</p>
                                  </div>
                                </div>
                                <div className="flex items-start space-x-3 p-3 bg-[#faf8f5] rounded-lg">
                                  <span className="text-[#b8a18a] mt-1">▹</span>
                                  <div>
                                    <p className="font-medium text-[#2d2d2d]">진로 및 학업</p>
                                    <p className="text-sm text-[#666666]">진로 선택, 학업 문제 등</p>
                                  </div>
                                </div>
                                <div className="flex items-start space-x-3 p-3 bg-[#faf8f5] rounded-lg">
                                  <span className="text-[#ccb59f] mt-1">▹</span>
                                  <div>
                                    <p className="font-medium text-[#2d2d2d]">자기 이해 및 성장</p>
                                    <p className="text-sm text-[#666666]">자아 탐색, 개인적 성장</p>
                                  </div>
                                </div>
                                <div className="flex items-start space-x-3 p-3 bg-[#faf8f5] rounded-lg">
                                  <span className="text-[#9d8b73] mt-1">▹</span>
                                  <div>
                                    <p className="font-medium text-[#2d2d2d]">상실과 애도</p>
                                    <p className="text-sm text-[#666666]">죽음, 이별 등으로 인한 상실감</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* 부부 및 커플상담 */}
                        <div className="bg-[#f7f3ee] p-5 rounded-lg border border-[#ccb59f]">
                          <h4 className="font-bold text-[#2d2d2d] mb-4 text-lg flex items-center">
                            <span className="mr-2">■</span>부부 및 커플 상담
                          </h4>

                          <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                            <h5 className="font-semibold text-[#2d2d2d] mb-3 flex items-center">
                              <span className="mr-2">►</span>상담 주제
                            </h5>
                            <div className="space-y-3">
                              <div className="flex items-center space-x-3 p-3 bg-[#faf8f5] rounded-lg">
                                <span className="text-[#ccb59f] ">▹</span>
                                <div>
                                  <p className="font-medium text-[#2d2d2d]">의사소통</p>
                                </div>
                              </div>
                              <div className="flex items-center space-x-3 p-3 bg-[#faf8f5] rounded-lg">
                                <span className="text-[#a08c75] ">▹</span>
                                <div>
                                  <p className="font-medium text-[#2d2d2d]">성 관련 갈등</p>
                                </div>
                              </div>
                              <div className="flex items-center space-x-3 p-3 bg-[#faf8f5] rounded-lg">
                                <span className="text-[#8b7355] ">▹</span>
                                <div>
                                  <p className="font-medium text-[#2d2d2d]">관계 갈등</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* 가족상담 */}
                        <div className="bg-[#f5f1ec] p-5 rounded-lg border border-[#ccb59f]">
                          <h4 className="font-bold text-[#2d2d2d] mb-4 text-lg flex items-center">
                            <span className="mr-2">■</span>가족 상담
                          </h4>

                          <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                            <h5 className="font-semibold text-[#2d2d2d] mb-3 flex items-center">
                              <span className="mr-2">►</span>상담 주제
                            </h5>
                            <div className="space-y-3">
                              <div className="flex items-center space-x-3 p-3 bg-[#faf8f5] rounded-lg">
                                <span className="text-[#ccb59f]">▹</span> {/* mt-1 제거 */}
                                <div>
                                  <p className="font-medium text-[#2d2d2d]">부모-자녀 관계 갈등</p>
                                </div>
                              </div>
                              <div className="flex items-center space-x-3 p-3 bg-[#faf8f5] rounded-lg">
                                <span className="text-[#ccb59f]">▹</span> {/* mt-1 제거 */}
                                <div>
                                  <p className="font-medium text-[#2d2d2d]">가족 구성원 간의 이해 및 관계 회복</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {index === 4 && (
                      <div className="space-y-6">

                        {/* 종합심리평가 */}
                        <div className="bg-[#f5f1ec] p-5 rounded-lg border border-[#ccb59f]">
                          <h4 className="font-bold text-[#2d2d2d] mb-4 text-lg flex items-center">
                            <span className="mr-2">■</span>종합심리평가(full-battery)
                          </h4>

                          <div className="space-y-4">
                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                                <span className="mr-2">►</span>대상
                              </h5>
                              <p className="text-[#666666]">종합적인 인지 및 사고 정서, 성격에 대한 깊이 있는 이해를 원하는 청소년 및 성인</p>
                            </div>

                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-3 flex items-center">
                                <span className="mr-2">►</span>실시 항목
                              </h5>
                              <div className="text-sm text-[#666666] space-y-1">
                                <p>• 평가 면접, BGT</p>
                                <p>• 웩슬러 지능검사(K-WAIS-IV/K-WISC-V)</p>
                                <p>• 그림검사(HTP 및 KFD)</p>
                                <p>• 주제통각검사(TAT), 로르샤하(Rorschach)</p>
                                <p>• 문장완성검사(SCT)</p>
                                <p>• 다면적 인성검사(MMPI-2/A)</p>
                                <p>• 기질 및 성격 검사(TCI/JTCI)</p>
                              </div>
                            </div>

                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                                <span className="mr-2">►</span>소요시간
                              </h5>
                              <div className="text-sm text-[#666666] space-y-1">
                                <p>• 평가 실시: 약 3~4시간</p>
                                <p>• 자기보고식 검사작성: 약 2시간</p>
                                <p>• 해석 상담: 50분</p>
                                <p className="text-[#ccb59f] font-medium mt-2">※ 해석상담은 검사 실시 1주일 이후 진행되며, 심리평가 보고서가 제공됩니다.</p>
                              </div>
                            </div>

                            <div className="bg-[#ede4d9] p-4 rounded-lg">
                              <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                                <span className="mr-2">►</span>비용
                              </h5>
                              <p className="text-[#2d2d2d] font-bold">성인 45만원 / 청소년 50만원(부모 성격 검사 포함)</p>
                            </div>
                          </div>
                        </div>

                        {/* 심층성격평가 */}
                        <div className="bg-[#f7f3ee] p-5 rounded-lg border border-[#ccb59f]">
                          <h4 className="font-bold text-[#2d2d2d] mb-4 text-lg flex items-center">
                            <span className="mr-2">■</span>심층성격평가
                          </h4>

                          <div className="space-y-4">
                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                                <span className="mr-2">►</span>대상
                              </h5>
                              <p className="text-[#666666]">자신의 성격과 정서 상태에 대한 객관적인 이해와 더불어 무의식적인 욕구나 갈등, 반복되는 대인 관계 패턴과 같은 심층적인 내면에 대한 이해를 원하는 성인</p>
                            </div>

                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-3 flex items-center">
                                <span className="mr-2">►</span>실시 항목
                              </h5>
                              <div className="text-sm text-[#666666] space-y-1">
                                <p>• 평가 면접, BGT</p>
                                <p>• 그림검사(HTP 및 KFD)</p>
                                <p>• 주제통각검사(TAT), 로르샤하(Rorschach)</p>
                                <p>• 문장완성검사(SCT)</p>
                                <p>• 다면적 인성검사(MMPI-2)</p>
                                <p>• 기질 및 성격 검사(TCI)</p>
                              </div>
                            </div>

                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                                <span className="mr-2">►</span>소요시간
                              </h5>
                              <div className="text-sm text-[#666666] space-y-1">
                                <p>• 평가 실시: 약 2~3시간</p>
                                <p>• 자기보고식 검사작성: 약 2시간</p>
                                <p>• 해석 상담: 50분</p>
                                <p className="text-[#ccb59f] font-medium mt-2">※ 해석상담은 검사 실시 1주일 이후 진행되며, 심리평가 보고서가 제공됩니다.</p>
                              </div>
                            </div>

                            <div className="bg-[#ede4d9] p-4 rounded-lg">
                              <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                                <span className="mr-2">►</span>비용
                              </h5>
                              <p className="text-[#2d2d2d] font-bold">30만원</p>
                            </div>
                          </div>
                        </div>

                        {/* 성격평가 */}
                        <div className="bg-[#f5f1ec] p-5 rounded-lg border border-[#ccb59f]">
                          <h4 className="font-bold text-[#2d2d2d] mb-4 text-lg flex items-center">
                            <span className="mr-2">■</span>성격평가
                          </h4>

                          <div className="space-y-4">
                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                                <span className="mr-2">►</span>대상
                              </h5>
                              <p className="text-[#666666]">현재 자신의 성격 및 정서 상태를 객관적으로 이해하고 싶은 청소년 및 성인</p>
                            </div>

                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-3 flex items-center">
                                <span className="mr-2">►</span>실시 항목
                              </h5>
                              <div className="text-sm text-[#666666] space-y-1">
                                <p>• 다면적 인성검사(MMPI-2/A)</p>
                                <p>• 기질 및 성격 검사(TCI/JTCI)</p>
                                <p>• 문장완성검사(SCT)</p>
                                <p>• 해석상담 50분</p>
                              </div>
                            </div>

                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                                <span className="mr-2">►</span>소요시간
                              </h5>
                              <div className="text-sm text-[#666666] space-y-1">
                                <p>• 자기보고식 검사작성: 약 2시간</p>
                                <p>• 해석 상담: 50분</p>
                              </div>
                            </div>

                            <div className="bg-[#ede4d9] p-4 rounded-lg">
                              <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                                <span className="mr-2">►</span>비용
                              </h5>
                              <p className="text-[#2d2d2d] font-bold">15만원</p>
                            </div>
                          </div>
                        </div>

                        {/* 진로평가 */}
                        <div className="bg-[#f7f3ee] p-5 rounded-lg border border-[#ccb59f]">
                          <h4 className="font-bold text-[#2d2d2d] mb-4 text-lg flex items-center">
                            <span className="mr-2">■</span>진로평가
                          </h4>

                          <div className="space-y-4">
                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                                <span className="mr-2">►</span>대상
                              </h5>
                              <p className="text-[#666666]">자신의 진로를 고민 중인 청소년 및 성인</p>
                            </div>

                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-3 flex items-center">
                                <span className="mr-2">►</span>실시 항목
                              </h5>
                              <div className="text-sm text-[#666666] space-y-1">
                                <p>• Holland 진로검사</p>
                                <p>• 기질 및 성격 검사(TCI/JTCI)</p>
                                <p>• 성격강점검사(CST)</p>
                                <p>• 해석상담 50분</p>
                              </div>
                            </div>

                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                                <span className="mr-2">►</span>소요시간
                              </h5>
                              <div className="text-sm text-[#666666] space-y-1">
                                <p>• 자기보고식 검사작성: 약 1시간</p>
                                <p>• 해석 상담: 50분</p>
                              </div>
                            </div>

                            <div className="bg-[#ede4d9] p-4 rounded-lg">
                              <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                                <span className="mr-2">►</span>비용
                              </h5>
                              <p className="text-[#2d2d2d] font-bold">15만원</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {index === 5 && (
                      <div className="space-y-6">

                        {/* 상담자 교육 */}
                        <div className="bg-[#f5f1ec] p-5 rounded-lg border border-[#ccb59f]">
                          <h4 className="font-bold text-[#2d2d2d] mb-4 text-lg flex items-center">
                            <span className="mr-2">■</span>상담자 교육
                          </h4>

                          <div className="space-y-4">
                            {/* 개인 수퍼비전 */}
                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-bold text-[#2d2d2d] mb-3 flex items-center">
                                <span className="mr-2 ">◆</span>개인 수퍼비전
                              </h5>
                              <hr className="border-t border-gray-200 mb-3" />
                              <div className="space-y-3">
                                <div>
                                  <h6 className="font-bold text-[#2d2d2d] mb-1 pl-2"> · 대상</h6>
                                  <p className="text-sm text-[#666666] pl-2">한국상담심리학회 상담심리사 자격취득을 위해 수련중인 수련생</p>
                                </div>
                                <div className="bg-[#f5f1ec] p-3 rounded-lg">
                                  <h6 className="font-bold text-[#2d2d2d] mb-1"> · 비용</h6>
                                  <p className="text-[#2d2d2d] text-sm">1회 수퍼비전(50분) 기준, 10만원</p>
                                  {/* <p className="text-sm text-[#8b7355]">(석사생 및 무급 수련생의 경우 10만원)</p> */}
                                </div>
                              </div>
                            </div>

                            {/* 집단 수퍼비전 */}
                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-bold text-[#2d2d2d] mb-3 flex items-center">
                                <span className="mr-2">◆</span>집단 수퍼비전
                              </h5>
                              <hr className="border-t border-gray-200 mb-3" />
                              <div className="space-y-3">
                                <div>
                                  <h6 className="font-bold text-[#2d2d2d] mb-1 pl-2"> · 대상</h6>
                                  <p className="text-sm text-[#666666] pl-2">한국상담심리학회 상담심리사 자격취득을 위해 수련 중인 또래 수련생 2-4명으로 구성된 1팀</p>
                                  <p className="text-xs text-[#999999] mt-1 pl-2">(매주 혹은 격주로 진행)</p>
                                </div>
                                <div className="bg-[#f5f1ec] p-3 rounded-lg">
                                  <h6 className="font-bold text-[#2d2d2d] mb-1"> · 비용</h6>
                                  <p className="text-[#2d2d2d] text-sm">1회 수퍼비전(70분) 기준, 15만원</p>
                                </div>
                              </div>
                            </div>

                            {/* 심리검사 개인 수퍼비전 */}
                            <div className="bg-white p-4 rounded-lg border border-[#e8ddd4]">
                              <h5 className="font-bold text-[#2d2d2d] mb-3 flex items-center">
                                <span className="mr-2">◆</span>심리검사 개인 수퍼비전
                              </h5>
                              <hr className="border-t border-gray-200 mb-3" />
                              <div className="space-y-3">
                                <div>
                                  <h6 className="font-bold text-[#2d2d2d] mb-1 pl-2"> · 대상</h6>
                                  <p className="text-sm text-[#666666] pl-2">한국상담심리학회 상담심리사 자격취득을 위해 수련중인 수련생</p>
                                </div>
                                <div className="bg-[#f5f1ec] p-3 rounded-lg">
                                  <h6 className="font-bold text-[#2d2d2d] mb-1"> · 비용</h6>
                                  <p className="text-[#2d2d2d] text-sm">1회 수퍼비전(50분) 기준, 10만원</p>
                                </div>
                              </div>
                            </div>

                            {/* 공개사례발표 */}
                            <div className="bg-white p-4 rounded-lg border border-[#ccb59f]">
                              <h5 className="font-semibold text-[#2d2d2d] mb-2 flex items-center">
                                <span className="mr-2">►</span>공개사례발표
                              </h5>
                              <p className="text-sm text-[#666666]">프로그램 진행 시 사전 공지 후 실시함</p>
                            </div>
                          </div>
                        </div>

                        {/* 집단 프로그램 */}
                        <div className="bg-[#f7f3ee] p-5 rounded-lg border border-[#ccb59f]">
                          <h4 className="font-bold text-[#2d2d2d] mb-4 text-lg flex items-center">
                            <span className="mr-2">►</span>집단 프로그램
                          </h4>

                          <div className="bg-white p-4 rounded-lg border border-[#e8ddd4] text-center">
                            <div className="text-[#ccb59f] mb-3">
                              <span className="text-3xl">📅</span>
                            </div>
                            <h5 className="font-semibold text-[#2d2d2d] mb-2">프로그램 안내</h5>
                            <p className="text-sm text-[#666666]">프로그램 진행 시 사전 공지 후 실시함</p>
                            <div className="mt-3 p-3 bg-[#f5f1ec] rounded-lg">
                              <p className="text-xs text-[#8b7355]">최신 프로그램 일정은 센터로 문의해주세요</p>
                            </div>
                          </div>
                        </div>

                        {/* 문의 안내 */}
                        <div className="bg-white p-4 rounded-lg border border-[#ccb59f]">
                          <h4 className="font-semibold text-[#2d2d2d] mb-3 flex items-center">
                            <Phone size={18} color="#ccb59f" className="mr-2" />
                            상담자 교육 문의
                          </h4>
                          <div className="space-y-2 text-sm text-[#666666]">
                            <p><strong>전화:</strong> 02-332-1404</p>
                            <p><strong>이메일:</strong> pulip13@naver.com</p>
                            <p className="text-[#ccb59f] mt-3">자세한 상담과 일정 조율을 위해 사전 연락 바랍니다.</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Phone Popup */}
      {showPhonePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg p-6 w-full max-w-xs mx-4 text-center">
            <h3 className="text-lg font-bold text-gray-800 mb-4">전화번호</h3>
            <p className="text-gray-600 mb-2">"신청하기 | 성심상담심리센터(홍대점)" 입니다.</p>
            <p className="text-2xl font-bold text-green-600 mb-4">02-332-1404</p>
            <p className="text-sm text-gray-500 mb-6">문자연결을 모바일에서 가능합니다.</p>
            <button
              onClick={() => setShowPhonePopup(false)}
              className="bg-gray-800 text-white px-6 py-2 rounded hover:bg-gray-700"
            >
              확인
            </button>
          </div>
        </div>
      )}

      {/* Message Popup */}
      {showMessagePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg p-6 w-full max-w-xs mx-4 text-center">
            <h3 className="text-lg font-bold text-gray-800 mb-4">전화번호</h3>
            <p className="text-gray-600 mb-2">"신청하기 | 성심상담심리센터(홍대점)" 입니다.</p>
            <p className="text-2xl font-bold text-green-600 mb-4">02-332-1404</p>
            <p className="text-sm text-gray-500 mb-6">문자연결을 모바일에서 가능합니다.</p>
            <button
              onClick={() => setShowMessagePopup(false)}
              className="bg-gray-800 text-white px-6 py-2 rounded hover:bg-gray-700"
            >
              확인
            </button>
          </div>
        </div>
      )}
      {/* Footer */}
      <footer className="bg-gray-800 text-white p-6 lg:py-12">
        <div className="lg:max-w-7xl lg:mx-auto lg:grid lg:grid-cols-3 lg:gap-8">
          <div className="mb-6 lg:mb-0">
            <h3 className="font-bold text-lg mb-4">성심상담심리센터(홍대점)</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p>대표전화: 02-332-1404</p>
              <p>이메일: pulip13@naver.com</p>
            </div>
          </div>

          <div className="mb-6 lg:mb-0">
            <h3 className="font-bold text-lg mb-4 lg:text-base">위치 정보</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p>주소: 서울 마포구 월드컵북로2길 85, 삼통빌딩 302호</p>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4 lg:text-base">사업자 정보</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <p>사업자등록번호: 106-92-16178 (대표 김길문·윤운영)</p>
              <p className="pt-4">Copyright ⓒ 2025 YouHazi. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CounselingCenter;